import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { MainRoutes } from './enums';
import { map, skipWhile, tap } from 'rxjs/operators';
import { FeedbackService } from './feedback.service';
import { TranslateService } from '@ngx-translate/core';
import { hasViewPermissionForPath } from './utilities';
import { selectAccount, selectUserDetails } from '../store/global/core-selectors';
import { concatLatestFrom } from '@ngrx/operators';

@Injectable({
  providedIn: 'root',
})
export class PermissionsGuard {
  constructor(
      private store: Store,
      private feedbackService: FeedbackService,
      private router: Router,
      private translate: TranslateService,
  ) {
  }

  /**
   * Checks if the user has the permissions to activate a route. If yes, returns true. If no,
   * redirects to home page, shows snackbar, and returns false.
   * @param route
   * @param state
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.store.select(selectUserDetails).pipe(
        skipWhile((userDetails) => !userDetails),
        concatLatestFrom(() => this.store.select(selectAccount)),
        map(([userDetails, acc]) => {
          const path = route.routeConfig.path;
          return hasViewPermissionForPath(userDetails, path, acc);
        }),
        // handle side effect with a tap operator
        tap((canActivate: boolean) => {
          if (!canActivate) {
            this.router.navigate([MainRoutes.HOME]).then();
            this.feedbackService.showInfoSnackbar({
              data:
                  {
                    userFriendlyMessage: this.translate.instant('ACCESS_DENIED',
                        { param: '/' + route.routeConfig.path }),
                  },
            });
          }
        }));
  }

}
